import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classnames from 'classnames';
import makeStyles from './../../makeStyles';
import isPlainObject from 'lodash/isPlainObject';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
var useStyles = makeStyles(function (theme) {
  var _responsiveSpacingCss;

  return {
    commonCss: function commonCss(props) {
      var spacing = props.spacing;
      return _extends({
        display: 'grid'
      }, spacing && spacing.style ? spacing.style : {});
    },
    responsiveSpacingCss: (_responsiveSpacingCss = {}, _responsiveSpacingCss[theme.breakpoints.up('xs')] = {
      padding: function padding(props) {
        return get(props, "spacing.xs.padding");
      },
      gridGap: function gridGap(props) {
        return get(props, "spacing.xs.gutter");
      }
    }, _responsiveSpacingCss[theme.breakpoints.up('sm')] = {
      padding: function padding(props) {
        return get(props, "spacing.sm.padding");
      },
      gridGap: function gridGap(props) {
        return get(props, "spacing.sm.gutter");
      }
    }, _responsiveSpacingCss[theme.breakpoints.up('md')] = {
      padding: function padding(props) {
        return get(props, "spacing.md.padding");
      },
      gridGap: function gridGap(props) {
        return get(props, "spacing.md.gutter");
      }
    }, _responsiveSpacingCss[theme.breakpoints.up('lg')] = {
      padding: function padding(props) {
        return get(props, "spacing.lg.padding");
      },
      gridGap: function gridGap(props) {
        return get(props, "spacing.lg.gutter");
      }
    }, _responsiveSpacingCss),
    responsiveCommonCss: function responsiveCommonCss(props) {
      var _ref;

      return _ref = {}, _ref[theme.breakpoints.up('xs')] = _extends({}, get(props, "spacing.xs.style")), _ref[theme.breakpoints.up('sm')] = _extends({}, get(props, "spacing.sm.style")), _ref[theme.breakpoints.up('md')] = _extends({}, get(props, "spacing.md.style")), _ref[theme.breakpoints.up('lg')] = _extends({}, get(props, "spacing.lg.style")), _ref;
    }
  };
}, {
  index: 2
});

var useCustomSpacing = function useCustomSpacing(props) {
  var _React$useState = React.useState(props),
      spacingOptions = _React$useState[0],
      setSpacingOptions = _React$useState[1];

  var _ref2 = spacingOptions || {
    spacing: {}
  },
      spacing = _ref2.spacing;

  var classes = useStyles({
    spacing: spacing
  });

  if (!isPlainObject(spacing) || isEmpty(spacing)) {
    return [undefined, setSpacingOptions];
  }

  return [classnames(classes.commonCss, classes.responsiveSpacingCss, classes.responsiveCommonCss), setSpacingOptions];
};

export default useCustomSpacing;